export default "__VITE_ASSET__mCI_GJG$__"